export default __webpack_public_path__ + "static/media/FileBlue.2fadddec.svg";